import { struct, union } from 'io-ts/Decoder';

import { Id as ImageId } from '../../../../whole-house/image/Id';
import { Id as TakeOffId } from '../../../../whole-house/take-off/Id';

export const Query = union(
	struct({
		imageId: ImageId,
	}),
	struct({
		takeOffId: TakeOffId,
	})
);
